import { render, staticRenderFns } from "./IsNewOrActive.vue?vue&type=template&id=71501ff5&scoped=true&"
import script from "./IsNewOrActive.vue?vue&type=script&lang=js&"
export * from "./IsNewOrActive.vue?vue&type=script&lang=js&"
import style0 from "./IsNewOrActive.vue?vue&type=style&index=0&id=71501ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71501ff5",
  null
  
)

export default component.exports